import { render, staticRenderFns } from "./editGift.vue?vue&type=template&id=46f16832&scoped=true&"
import script from "./editGift.vue?vue&type=script&lang=js&"
export * from "./editGift.vue?vue&type=script&lang=js&"
import style0 from "./editGift.vue?vue&type=style&index=0&id=46f16832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f16832",
  null
  
)

export default component.exports